<template>
    <div class="col-md-12">
        <h2 class="text-center">Zaloguj się</h2>

        <div class="card col-md-8 col-lg-3">
            <loader :active="loading" />

            <div v-if="!clientChosen">
                <div  class="card-header">
                    <h5> Wybierz konto </h5>
                </div>

                <div class="card-body">
                    <div v-for="activeClient in activeClients" :key="activeClient.clid" @click="chooseClient(activeClient)" :class="[`active-client`, !activeClient.canLogin ? `disabled` : ``]">
                        <client :client="activeClient" badge="none"/>
                    </div>
                    <div v-if="!activeClients" class="no-active">
                        <span>Nie wykryto Cię na serwerze</span>
                    </div>
                </div>

                <div v-if="canRefresh" class="card-footer">
                    <div class="form-group">
                        <button class="btn btn-primary" @click="refreshClients()">
                            <span><font-awesome-icon icon="sync"/> Odśwież</span>
                        </button>
                    </div>
                </div>
            </div>

            <div v-if="clientChosen && !channelChosen">
                <div  class="card-header">
                    <h5> Wybierz kanał </h5>
                </div>

                <div class="card-body">
                    <div v-for="(channelInfo, channelId) in clientChosen.channelsInfo" :key="channelId" @click="chooseChannel(channelId)">
                        <select-channel :channel="channelInfo"/>
                    </div>
                </div>

                <div class="card-footer">
                    <div class="form-group">
                        <button class="btn btn-danger" @click="goBack()">
                            <span><font-awesome-icon icon="arrow-left"/> Powrót</span>
                        </button>
                    </div>
                </div>
            </div>

            <form name="form" @submit.prevent="handleLogin" v-if="clientChosen && channelChosen" >
                <div class="card-header">
                    <h5> Wpisz token </h5>
                </div>

                <div class="card-body">
                    <div class="form-group">
                        <label for="token">Token</label>
                        <input
                                v-model="token"
                                v-validate="'required'"
                                type="text"
                                class="form-control"
                                name="token"
                        />
                        <div
                                v-if="errors.has('token')"
                                class="alert alert-danger"
                                role="alert"
                        >Token jest wymagany!</div>
                    </div>
                </div>

                <div class="card-footer">
                    <div class="form-group">
                        <button class="btn btn-success" :disabled="loading">
                            <span><font-awesome-icon icon="sign-in-alt"/> Zaloguj</span>
                        </button>
                    </div>

                    <div class="form-group">
                        <button class="btn btn-danger" @click="goBack()">
                            <span><font-awesome-icon icon="arrow-left"/> Powrót</span>
                        </button>
                    </div>
                </div>
            </form>

            <div class="form-group">
                <div v-if="message" class="alert alert-danger" role="alert">{{message}}</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Login',
        data() {
            return {
                token: '',
                loading: true,
                message: '',
                activeClients: [],
                clientChosen: false,
                channelChosen: false,
                canRefresh: true,
                shouldRefresh: true,
                onGoing: false
            };
        },
        computed: {
            loggedIn() {
                return this.$store.state.auth.status.loggedIn;
            }
        },
        created() {
            if (this.loggedIn) {
                this.$router.push({name: 'home'});
            } else {
                this.getClients();
            }
        },
        methods: {
            getClients() {
                if (!this.shouldRefresh) return;
                if (this.onGoing) return;

                this.onGoing = true;

                this.$store.dispatch('auth/getClients').then(
                    response => {
                        this.activeClients = response.clients.length == 0 ? null : response.clients;
                        this.message = '';
                        this.loading = false;
                        this.shouldRefresh = true;
                        this.onGoing = false;
                        this.setCanRefresh();
                        setTimeout(()=>{
                            this.getClients();
                        },5*1000);
                    },
                    error => {
                        this.loading = false;
                        this.message = "Undefinded error";
                        this.onGoing = false;

                        if (error.response && error.response.data && error.response.data.message)
                            this.message = error.response.data.message;
                        else if (error.message)
                            this.message = error.message;
                        else if (error.toString())
                            this.message = error.toString();

                        this.shouldRefresh = true;
                        setTimeout(()=>{
                            this.getClients();
                        },5*1000);
                    }
                );
            },
            chooseClient(client) {
                if (!client.canLogin) {
                    this.message = 'Nie posiadasz kanału Premium';
                    return;
                }

                this.loading = true;
                this.shouldRefresh = false;
                this.clientChosen = client;

                if (!client.channelsInfo || Object.keys(client.channelsInfo).length <= 1) { // Dostep do jednego kanalu lub admin
                    this.channelChosen = (client.channelsInfo ? Object.keys(client.channelsInfo)[0] : -1);
                    this.sentToken();
                } else { // Dostep do wiekszej ilosc
                    this.loading = false;
                }
            },
            chooseChannel(channel) {
                this.loading = true;
                this.shouldRefresh = false;
                this.channelChosen = channel;

                this.sentToken();
            },
            sentToken() {
                this.$store.dispatch('auth/sentToken', {'user': this.clientChosen, 'channelId': this.channelChosen}).then(
                    () => {
                        this.message = '';
                        this.loading = false;
                    },
                    error => {
                        this.loading = false;
                        this.message = "Undefinded error";

                        if (error.response && error.response.data && error.response.data.message)
                            this.message = error.response.data.message;
                        else if (error.message)
                            this.message = error.message;
                        else if (error.toString())
                            this.message = error.toString();
                    }
                );
            },
            goBack() {
                this.shouldRefresh = true;
                this.clientChosen = false;
                this.channelChosen = false;
                this.getClients();
            },
            refreshClients() {
                if (this.canRefresh) {
                    this.loading = true;
                    this.clientChosen = false;
                    this.channelChosen = false;
                    this.canRefresh = false;
                    this.getClients();
                }
            },
            setCanRefresh() {
                this.canRefresh = true;
            },
            handleLogin() {
                this.loading = true;
                this.$validator.validateAll().then(isValid => {
                    if (!isValid) {
                        this.loading = false;
                        return;
                    }

                    if (this.token) {
                        this.$store.dispatch('auth/login', {'user': this.clientChosen, 'channelId': this.channelChosen, 'token': this.token}).then(
                            () => {
                                this.message = '';
                                this.$router.push('/home');
                            },
                            error => {
                                this.loading = false;
                                this.message = "Undefinded error";

                                if (error.response && error.response.data && error.response.data.message)
                                    this.message = error.response.data.message;
                                else if (error.message)
                                    this.message = error.message;
                                else if (error.toString())
                                    this.message = error.toString();
                            }
                        );
                    }
                });
            }
        }
    };
</script>

<style scoped>
    .active-client {
        background: rgba(0,0,0,0.1);
        padding: 15px 50px;
        margin: 10px;
        text-align: center;
        border-radius: 5px;
        font-weight: bold;
        cursor: pointer;
        transition: all .2s ease-in-out;
    }

    .active-client:hover:not(.disabled) {
        background: rgba(0,0,0,0.3);
    }

    .active-client.disabled {
        cursor: not-allowed;
        background: rgba(0,0,0,0.5);
    }

    .no-active {
        text-align: center;
        font-size: 1.3em;
    }
</style>